import { useQuery } from "@tanstack/react-query";
import { getInfraList } from "../../api/apiCallManager";

const useInfraFormData = (id) => {
  return useQuery({
    queryKey: ["_keyinfraFormList", id],
    queryFn: () => getInfraList(id),
  });
};

export default useInfraFormData;
